import { StyleSheet, Dimensions, I18nManager, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width: screenWidth } = Dimensions.get('window');

export default StyleSheet.create({
  title: {
    fontSize: 25,
    fontWeight: 'normal',
    fontFamily: Fonts.type.VodafoneLt,
    marginTop: 19,
    color: Colors.blackTwo,
  },
  twoInputsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  halfSizeInput: {
    // width: screenWidth * 0.4,
    flex: 1
  },
  secureContainer: (theme, isSecureContainerBottomBorder, isCardNameVisible) => ({
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 23,
    marginTop: 8,
    borderColor: theme.colors.divider,
    borderBottomWidth: isSecureContainerBottomBorder ? 1 : 0,
    paddingBottom: !isSecureContainerBottomBorder ? 8 : isCardNameVisible ? 60 : 130, //(10+10+50+60) input margin+height+ initial padding to have the same size in both cases
  }),
  cardNameInputContainer: {
    marginTop: 10,
    marginBottom: 10,
    height: 50,
  },
  textInputContainerStyle: {
    height: 50,
  },
  lockIcon: {
    alignSelf: 'center',
    marginLeft: 4,
  },
  secureText: theme => ({
    fontSize: 14,
    marginLeft: 17,
    lineHeight: 18,
    width: screenWidth * 0.6,
    color: theme.colors.textColorTwo,
  }),
  saveToggleConianer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 10,
  },
  saveToggleText: theme => ({
    fontFamily: Fonts.type.VFFont,
    marginLeft: 7.5,
    color: theme.colors.textColor,
    fontSize: 16.7,
  }),
  primaryButton: theme => ({
    backgroundColor: theme.colors.buttons.primary.default,
  }),
  primaryButtonDisabled: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  deleteButton: theme => ({
    marginTop: 20,
    marginBottom: 20,
    color: theme.colors.textColorThree,
  }),
  customHelperText: theme => ({
    color: theme.colors.subtitle,
    flex: 1,
    fontSize: 14.6,
    lineHeight: 18.7,
    marginLeft: I18nManager.isRTL ? 0 : 7,
    marginRight: I18nManager.isRTL ? 7 : 0,
    paddingTop: Platform.OS === 'ios' ? 3 : 1,
  }),
  helperError: theme => ({
    color: theme.colors.textInput.error.tintColor,
  }),
  primaryButtonText: theme => ({
    color: theme.colors.textButtons.primary.default,
  }),
  primaryButtonDisabledText: theme => ({
    color: theme.colors.textButtons.tertiary.default,
  }),
});
